module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "purchaseManage-content"
  }, [_c('banner', {
    attrs: {
      "clazz": "purchaseManage-banner",
      "url": "purchaseManage"
    }
  }, [_c('template', {
    slot: "buttons"
  }, [_c('el-button', {
    staticClass: "banner-button",
    attrs: {
      "round": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.goMore('caigouxunyuan-banner-tiyan')
      }
    }
  }, [_vm._v("申请体验")]), _vm._v(" "), _c('el-button', {
    staticClass: "banner-button",
    attrs: {
      "round": ""
    },
    on: {
      "click": _vm.goConsult
    }
  }, [_vm._v("立即咨询")])], 1)], 2), _vm._v(" "), _c('div', {
    staticClass: "purchaseManage-section1 tc"
  }, [_c('h1', {
    staticClass: "section1-title"
  }, [_vm._v("电子化采购寻源：打造企业高效透明寻源平台")]), _vm._v(" "), _c('div', {
    staticClass: "section1-divider dib"
  }), _vm._v(" "), _c('div', {
    staticClass: "section1-content"
  }, [_c('h1', {
    staticClass: "content-header"
  }, [_vm._v("从采购需求端驱动企业采购降本增效，满足不同品类对寻源模式的差异化需求")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('p', {
    staticClass: "content-footer"
  }, [_vm._v("采购寻源管理平台为企业实现从需求提交与收集、供应商开发、采购招标、询比价、竞价、合同管理等全流程透明化、电子化过程管理。")]), _vm._v(" "), _c('div', {
    staticClass: "content-button"
  }, [_c('el-button', {
    staticClass: "detail-info",
    attrs: {
      "round": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.goMore('caigouxunyuan-pingtai-xiangqing')
      }
    }
  }, [_vm._v("获取详情介绍\n        ")]), _vm._v(" "), _c('el-button', {
    staticClass: "consult-now",
    attrs: {
      "round": ""
    },
    on: {
      "click": _vm.goConsult
    }
  }, [_vm._v("立即咨询")])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "purchaseManage-section2 tc"
  }, [_c('h1', {
    staticClass: "section2-title"
  }, [_vm._v("管理谈判过程，加速决标，成本节约")]), _vm._v(" "), _c('div', {
    staticClass: "section2-divider dib"
  }), _vm._v(" "), _c('h1', {
    staticClass: "section2-subtitle"
  }, [_vm._v("实施科学管控寻源，执行多供应商在线谈判，结合竞价，比价工具，达到降本增效")]), _vm._v(" "), _c('div', {
    staticClass: "section2-main"
  }, [_c('div', {
    staticClass: "section2-choose dib"
  }, [_c('div', {
    staticClass: "left-list"
  }, _vm._l((_vm.collpaseItem), function(item) {
    return _c('div', {
      staticClass: "choice",
      class: _vm.choice === item.order ? 'is-choosed ' + item.order : item.order,
      on: {
        "mouseenter": function($event) {
          return _vm.chooseTab(item.order)
        }
      }
    }, [_c('div', {
      staticClass: "choice-content"
    }, [_c('div', {
      staticClass: "icon-container dib"
    }, [_c('img', {
      directives: [{
        name: "lazy",
        rawName: "v-lazy",
        value: (item.icon),
        expression: "item.icon"
      }],
      staticClass: "icon",
      attrs: {
        "alt": item.text
      }
    })]), _vm._v(" "), _c('p', {
      staticClass: "text"
    }, [_vm._v(_vm._s(item.text))])]), _vm._v(" "), _c('div', {
      staticClass: "triangle"
    })])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "right-content"
  }, _vm._l((_vm.collpaseItem), function(item) {
    return _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.choice === item.order),
        expression: "choice === item.order"
      }],
      key: item.order,
      class: item.order + '-content'
    }, [_c('h2', {
      staticClass: "title"
    }, [_vm._v(_vm._s(item.subtitle))]), _vm._v(" "), _c('div', {
      staticClass: "text"
    }, _vm._l((item.content), function(subitem) {
      return _c('p', [_vm._v(_vm._s(subitem))])
    }), 0), _vm._v(" "), _c('img', {
      directives: [{
        name: "lazy",
        rawName: "v-lazy",
        value: (item.url),
        expression: "item.url"
      }],
      staticClass: "image",
      attrs: {
        "url": item.url,
        "alt": item.text
      }
    })])
  }), 0)])]), _vm._v(" "), _c('el-button', {
    staticClass: "consult-button",
    nativeOn: {
      "click": function($event) {
        return _vm.goMore('caigouxunyuan-guocheng-shiyong')
      }
    }
  }, [_vm._v("立即试用")]), _vm._v(" "), _c('h1', {
    staticClass: "section2-title"
  }, [_vm._v("采购寻源平台价值")]), _vm._v(" "), _c('div', {
    staticClass: "section2-divider dib"
  }), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "section2-platformValue dib"
  }, [_c('ul', {
    staticClass: "platformValue-list"
  }, _vm._l((_vm.platformValueList), function(item) {
    return _c('li', {
      staticClass: "list-item"
    }, [_c('h2', {
      staticClass: "dib block tc"
    }, [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('div', {
      staticClass: "list-item-cont"
    }, _vm._l((item.content), function(subItem3) {
      return _c('div', {
        staticClass: "cont-item tc"
      }, [_vm._v(_vm._s(subItem3))])
    }), 0)])
  }), 0)])]), _vm._v(" "), _c('el-button', {
    staticClass: "consult-button",
    on: {
      "click": this.goConsult
    }
  }, [_vm._v("立即咨询")]), _vm._v(" "), _c('h1', {
    staticClass: "section2-title"
  }, [_vm._v("他们为什么使用甄云寻源系统？")]), _vm._v(" "), _c('div', {
    staticClass: "section2-divider dib"
  }), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "section2-systemlist tl dib"
  }, [_c('span', {
    staticClass: "expand-content dib"
  }, _vm._l((_vm.expandItemList), function(item, index) {
    return _c('div', {
      staticClass: "expandItem tc dib",
      class: index === 0 ? 'expand' : '',
      style: ({
        'backgroundImage': item.caig_img ? 'url(' + _vm.$global.globalPath + item.caig_img + ')' : ''
      }),
      on: {
        "mouseenter": function($event) {
          return _vm.listExpandOn(index)
        },
        "mouseleave": _vm.listExpandOff,
        "touchstart": function($event) {
          return _vm.listExpandOn(index)
        },
        "touchend": function($event) {
          return _vm.listExpandOn(index)
        }
      }
    }, [_c('div', {
      staticClass: "expandItemMask"
    }, [_c('img', {
      directives: [{
        name: "lazy",
        rawName: "v-lazy",
        value: (_vm.$global.globalPath + item.caig_logo),
        expression: "$global.globalPath + item.caig_logo"
      }],
      staticClass: "expandItemIcon",
      attrs: {
        "alt": item.title
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "expandItemTextContainer"
    }, [_c('p', {
      staticClass: "expandItemText dib textContent tl"
    }, [_vm._v(_vm._s(index === 0 ? item.caig_describe : item.title))]), _vm._v(" "), _c('p', {
      staticClass: "expandItemText textFooter tl"
    }, [_vm._v(_vm._s(item.origin ? '— — ' + item.caig_seo : ''))]), _vm._v(" "), _c('p', {
      staticClass: "expandShowDetail tc",
      on: {
        "click": function($event) {
          return _vm.goClientDetail(item.id, item.status)
        }
      }
    }, [_vm._v("了解案例详情 >")])])])])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "expandItem static tc dib",
    on: {
      "click": _vm.listMove
    }
  }, [_c('img', {
    staticClass: "expandItemIcon",
    attrs: {
      "src": require("../../assets/img/purchaseManage/arrow@2x.png"),
      "alt": "他们为什么使用甄云寻源系统"
    }
  })])])]), _vm._v(" "), _c('el-button', {
    staticClass: "get-detail",
    nativeOn: {
      "click": function($event) {
        return _vm.goMoreCase.apply(null, arguments)
      }
    }
  }, [_vm._v("获取更多案例")])], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-main"
  }, [_c('div', {
    staticClass: "contentBox first tc dib"
  }, [_c('img', {
    staticClass: "icon",
    attrs: {
      "src": require("../../assets/img/purchaseManage/platform-1@2x.png"),
      "alt": "对接ERP，OA等系统<"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("对接ERP，OA等系统"), _c('br'), _vm._v("收集采购寻源需求")])]), _vm._v(" "), _c('div', {
    staticClass: "contentBox second tc dib"
  }, [_c('img', {
    staticClass: "icon",
    attrs: {
      "src": require("../../assets/img/purchaseManage/platform-2@2x.png"),
      "alt": "制定招投标计划或咨询报价策略"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("制定招投标计划或"), _c('br'), _vm._v("询报价策略")])]), _vm._v(" "), _c('div', {
    staticClass: "contentBox third tc dib"
  }, [_c('img', {
    staticClass: "icon",
    attrs: {
      "src": require("../../assets/img/purchaseManage/platform-3@2x.png"),
      "alt": "寻源发布，潜在供应商的寻找与认证"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("寻源发布，潜在供应商"), _c('br'), _vm._v("的寻找与认证")])]), _vm._v(" "), _c('div', {
    staticClass: "contentBox fourth tc dib"
  }, [_c('img', {
    staticClass: "icon",
    attrs: {
      "src": require("../../assets/img/purchaseManage/platform-4@2x.png"),
      "alt": "供应商合作关系建立过程中的谈判与审核"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("供应商合作关系建立"), _c('br'), _vm._v("过程中的谈判与审核")])]), _vm._v(" "), _c('div', {
    staticClass: "contentBox fifth tc dib"
  }, [_c('img', {
    staticClass: "icon",
    attrs: {
      "src": require("../../assets/img/purchaseManage/platform-5@2x.png"),
      "alt": "供应选定与合同签署"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("供应选定与合同"), _c('br'), _vm._v("签署")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f3232028"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/product/purchaseManage.vue
// module id = 451
// module chunks = 12